var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionBubble = function SvgQuestionBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 69,
    viewBox: "0 0 66 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9757 52.7162C53.5234 53.9997 52.1074 55.2061 50.5046 56.2488L50.5973 65.6377C50.6045 66.374 50.1058 66.9779 49.4833 66.9867C49.2302 66.99 48.9834 66.8926 48.7828 66.71L41.6455 60.2151C38.9702 60.9434 36.1484 61.333 33.2325 61.333C16.1116 61.333 2.23242 47.9015 2.23242 31.333C2.23242 14.7645 16.1116 1.33301 33.2325 1.33301C50.3533 1.33301 64.2324 14.7645 64.2324 31.333C64.2324 35.9188 63.1692 40.2643 61.2683 44.1513C60.9177 44.8681 60.5386 45.5694 60.1325 46.2537C60.1325 46.2537 59.3385 47.6663 57.7507 49.6663C56.1627 51.6663 54.9757 52.7162 54.9757 52.7162Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5645 27.333C22.7737 27.333 24.5645 29.1239 24.5645 31.333C24.5645 33.5421 22.7737 35.333 20.5645 35.333C18.3554 35.333 16.5645 33.5421 16.5645 31.333C16.5645 29.1239 18.3554 27.333 20.5645 27.333ZM33.2312 27.333C35.4403 27.333 37.2312 29.1239 37.2312 31.333C37.2312 33.5421 35.4403 35.333 33.2312 35.333C31.022 35.333 29.2312 33.5421 29.2312 31.333C29.2312 29.1239 31.022 27.333 33.2312 27.333ZM45.8978 27.333C48.107 27.333 49.8978 29.1239 49.8978 31.333C49.8978 33.5421 48.107 35.333 45.8978 35.333C43.6887 35.333 41.8978 33.5421 41.8978 31.333C41.8978 29.1239 43.6887 27.333 45.8978 27.333Z",
    stroke: "#757575",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.151 23.2384C10.6184 24.2994 10.169 25.3933 9.8093 26.5139",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2472 10.7158C19.8787 12.8007 16.1906 15.7499 13.5254 19.2805",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
};
export default SvgQuestionBubble;